import React, { useEffect, useRef, useState } from 'react';
import classes from './Admissions.module.scss';
import { CustomButton, CustomExpandableStepper, CustomImage, CustomImageSlider } from '../../../atoms';
import { useNavigate } from 'react-router-dom';
import titlestar from '../../../../assets/images/institute/title-star.svg';
import admission1Option1 from '../../../../assets/images/institute/admissions/admission1Option1.png';
import admission1Option2 from '../../../../assets/images/institute/admissions/admission1Option2.png';
import admission1Option3 from '../../../../assets/images/institute/admissions/admission1Option3.png';
import admission2Option1 from '../../../../assets/images/institute/admissions/admission2Option1.png';
import admission2Option2 from '../../../../assets/images/institute/admissions/admission2Option2.png';
import admission2Option3 from '../../../../assets/images/institute/admissions/admission2Option3.png';
import admission3Option1 from '../../../../assets/images/institute/admissions/admission3Option1.png';
import admission3Option2 from '../../../../assets/images/institute/admissions/admission3Option2.png';
import admission3Option3 from '../../../../assets/images/institute/admissions/admission3Option3.png';
import admission1Option1Mobile from '../../../../assets/images/institute/admissions/admission1Option1Mobile.png';
import admission1Option2Mobile from '../../../../assets/images/institute/admissions/admission1Option2Mobile.png';
import admission1Option3Mobile from '../../../../assets/images/institute/admissions/admission1Option3Mobile.png';
import admission2Option1Mobile from '../../../../assets/images/institute/admissions/admission2Option1Mobile.png';
import admission2Option2Mobile from '../../../../assets/images/institute/admissions/admission2Option2Mobile.png';
import admission2Option3Mobile from '../../../../assets/images/institute/admissions/admission2Option3Mobile.png';
import admission3Option1Mobile from '../../../../assets/images/institute/admissions/admission3Option1Mobile.png';
import admission3Option2Mobile from '../../../../assets/images/institute/admissions/admission3Option2Mobile.png';
import admission3Option3Mobile from '../../../../assets/images/institute/admissions/admission3Option3Mobile.png';
import admissionPortal from '../../../../assets/images/institute/admissions/admissionPortal.png';
import admissionPortalMobile from '../../../../assets/images/institute/admissions/admissionPortalMobile.png';
import LiveFeatures from '../LiveFeatures/LiveFeatures';
import { useOnScreen } from '../../../../hooks';

const Admissions = () => {
  const navigate = useNavigate();
  const [selectedIdx, setSelectedIdx] = useState(1);
  const [selectedIdx1, setSelectedIdx1] = useState(1);
  const [selectedIdx2, setSelectedIdx2] = useState(1);

  const featureOption1Interval = useRef(null);
  const featureOption1Ref = useRef(null);
  const featureOption2Interval = useRef(null);
  const featureOption2Ref = useRef(null);
  const featureOption3Interval = useRef(null);
  const featureOption3Ref = useRef(null);

  const isFeatureOption1Visible = useOnScreen(featureOption1Ref);
  const isFeatureOption2Visible = useOnScreen(featureOption2Ref);
  const isFeatureOption3Visible = useOnScreen(featureOption3Ref);

  const images = {
    option1: [admission1Option1, admission1Option2, admission1Option3],
    option2: [admission2Option1, admission2Option2, admission2Option3],
    option3: [admission3Option1, admission3Option2, admission3Option3]
  };

  const imagesMobile = {
    option1: [admission1Option1Mobile, admission1Option2Mobile, admission1Option3Mobile],
    option2: [admission2Option1Mobile, admission2Option2Mobile, admission2Option3Mobile],
    option3: [admission3Option1Mobile, admission3Option2Mobile, admission3Option3Mobile]
  };

  const admissionOptions = [
    {
      id: 'option1',
      title: 'FEATURE 1',
      heading: {
        gradientText: 'Customisable Workflows',
        normalText: 'Built for your Admissions',
      },
      description: 'Every institute is unique. Create applicant journeys that match your process without compromising on the candidate experience.',
      ref: featureOption1Ref,
      images: images.option1,
      imagesMobile: imagesMobile.option1,
      selectedIdx: selectedIdx,
      setSelectedIdx: setSelectedIdx,
      descriptionOrder: classes.Feature1_Order1,
      imageOrder: classes.Feature1_Order2,
      bgColor: classes.Gray_Color,
      gap: classes.Feature1_Gap,
      options: [
        {
          title: 'Flexible Worflows for Modern Schools',
          description: 'Guide parents ease and automate follow-ups to simplify your K-12 admissions',
        },
        {
          title: 'Define Your Higher Ed Workflow',
          description: 'Manage exams, reviews, and offers - your entire admissions journey, simplified.',
        },
        {
          title: 'Custom Workflows for Every Program',
          description: 'Build course-specific workflows. Include interviews or skip steps as per your process.',
        },
      ]
    },
    {
      id: 'option2',
      title: 'FEATURE 2',
      heading: {
        gradientText: 'Run Your Entire Admissions',
        normalText: 'via One Dashboard',
      },
      description: 'Track every stage in real time - from lead source to conversions to fee collection.',
      ref: featureOption2Ref,
      images: images.option2,
      imagesMobile: imagesMobile.option2,
      selectedIdx: selectedIdx1,
      setSelectedIdx: setSelectedIdx1,
      descriptionOrder: classes.Feature2_Order2,
      imageOrder: classes.Feature2_Order1,
      bgColor: classes.White_Color,
      gap: classes.Feature2_Gap,
      options: [
        {
          title: 'Know Where Leads Come From',
          description: 'See if leads came via Google, Facebook, walkings, or referrals.',
        },
        {
          title: 'Track Your Application',
          description: `View Each application's status, stage and assigned counsellor - no more Excel or Whatsapp.`,
        },
        {
          title: 'Understand Conversions Instantly',
          description: 'Track how many applicants moved from enquiry to admission. Spot drop-offs and imporove your funnel.',
        },
      ]
    },
    {
      id: 'option3',
      title: 'FEATURE 3',
      heading: {
        gradientText: 'Smarter Admissions,',
        normalText: 'Less Effort',
      },
      description: 'Keep applicants informed, track payments, and control access - all in one place.',
      ref: featureOption3Ref,
      images: images.option3,
      imagesMobile: imagesMobile.option3,
      selectedIdx: selectedIdx2,
      setSelectedIdx: setSelectedIdx2,
      descriptionOrder: classes.Feature3_Order1,
      imageOrder: classes.Feature3_Order2,
      bgColor: classes.Gray_Color,
      gap: classes.Feature3_Gap,
      options: [
        {
          title: 'Notify applicants at each stage',
          description: `Set up communication for each stage - like "From Submitted", "Under Review", "Interview Scheduled" or "Final Offer Shared".`,
        },
        {
          title: 'Track Transactions',
          description: 'Monitor fee calculations, settlements, and payment status in realtime',
        },
        {
          title: 'Secure, Role-based Access',
          description: 'Set clear access roles & permissions for counsellors, admins, and finance teams.',
        }
        ,
      ]
    },
  ];

  const startInterval = (callback, intervalRef) => {
    intervalRef.current = setInterval(callback, 5000);
  };

  const stopInterval = (intervalRef) => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  useEffect(() => {
    if (isFeatureOption1Visible) {
      !featureOption1Interval.current &&
        startInterval(() => {


          setSelectedIdx((oldIdx) => (oldIdx === 3 ? 1 : oldIdx + 1));
        }, featureOption1Interval);
    } else {
      featureOption1Interval.current &&
        stopInterval(featureOption1Interval);
    }
  }, [isFeatureOption1Visible]);

  useEffect(() => {
    if (isFeatureOption2Visible) {
      !featureOption2Interval.current &&
        startInterval(() => {

          setSelectedIdx1((oldIdx) =>
            oldIdx === 3 ? 1 : oldIdx + 1
          );
        }, featureOption2Interval);
    } else {
      featureOption2Interval.current &&
        stopInterval(featureOption2Interval);
    }
  }, [isFeatureOption2Visible]);

  useEffect(() => {
    if (isFeatureOption3Visible) {
      !featureOption3Interval.current &&
        startInterval(() => {

          setSelectedIdx2((oldIdx) =>
            oldIdx === 3 ? 1 : oldIdx + 1
          );
        }, featureOption3Interval);
    } else {
      featureOption3Interval.current &&
        stopInterval(featureOption3Interval);
    }
  }, [isFeatureOption3Visible]);

  return (
    <div className={classes.Admissions}>
      <div className={classes.Admissions__HeaderSection}>
        <h2
          className={classes.Admissions__Header}>
          Admissions Software that Adapts to{' '}
          <span className={classes.Admissions__YouText}>You</span>
        </h2>
        <div className={classes.Admissions__Description}>ARC lets you define workflows, assign roles, track performance, and manage admissions your way. No more forcing your team into rigid software. Configure every aspect of ARC to match your existing processes</div>
        <div>
          <CustomButton
            className={classes.Admissions__ScheduleBtn}
            onClick={() => navigate('/contact')}
            text='Schedule demo'
          >
          </CustomButton>
        </div>
      </div>
      <div className={classes.ImageWrapper}>
        <CustomImage
          title='admissions'
          className={classes.AdmissionImage}
          images={[
            {
              media: '468',
              src: admissionPortalMobile,
            }
          ]}
          lazy={false}
          defaultImg={admissionPortal}
        />
      </div>
      <div className={classes.Admissions__FeatureSection}>
        <div>
          {admissionOptions.map((item) => {
            return (
              <section key={item.id} className={`${classes.FeatureWrapper} ${item.bgColor}`}>
                <div className={`${classes.FeatureWrapper__Container} ${item.gap}`}>
                  <div className={`${classes.FeatureWrapper__LeftSection} ${item.descriptionOrder}`}>
                    <div className={classes.FeatureWrapper__TitleWrapper}>
                      <img className={classes.FeatureWrapper__Star} src={titlestar} alt="star icon" />
                      <p className={classes.FeatureWrapper__Title}>{item.title}</p>
                    </div>
                    <div className={classes.FeatureWrapper__HeadingWrapper}>
                      <h2 className={classes.FeatureWrapper__GradientText}>{item.heading.gradientText}</h2>
                      <h2 className={classes.FeatureWrapper__NormalText}>{item.heading.normalText}</h2>
                    </div>
                    <div className={classes.FeatureWrapper__DiscriptionWrapper}>
                      <p>{item.description}</p>
                    </div>
                    <div className={classes.MobileView}>
                      <CustomImageSlider item={item} />
                    </div>
                    <div className={`${classes.DesktopView} ${classes.Stepper_Wrapper}`}>
                      <CustomExpandableStepper item={item}/>
                    </div>
                  </div>
                  <div className={`${classes.FeatureWrapper__RightSection} ${classes.DesktopView} ${item.imageOrder}`} ref={item?.ref}>
                    {item.selectedIdx >= 1 && (
                      <div className={`${item.imageOrder}`}>
                        <img
                          className={`img-fluid image_desktop ${classes.Feature_DesktopImg}`}
                          src={images[item.id][item.selectedIdx - 1]}
                          alt=''
                        />
                      </div>
                    )}
                  </div>
                </div>
              </section>
            )
          })}
        </div>

        {/* Mobile Version */}
      </div>
      <LiveFeatures />
    </div>
  )
}

export default Admissions